import { Circle, StyledOption } from './StyledComponents';

export const Option = props => {
  const {
    children,
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerRef,
    innerProps,
    data,
  } = props;

  return (
    <div
      style={{ ...getStyles('option', props), overflow: 'hidden' }}
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className,
      )}
      ref={innerRef}
      {...innerProps}
    >
      <Circle color={data.color} isSettings={data.isSettings} />
      <StyledOption title={children}>{children}</StyledOption>
    </div>
  );
};
